import { createPortal } from "react-dom";
import { MouseEventHandler } from "react";
//--------------------------------------------------------------------------------------------
export default function Notification({
    closeIt, 
    title, 
    msg, 

    confirm, 
    titleColor, 
    titleBgColor, 
    msgColor, 
    msgBgColor, 
    onYes, 
    onNo, 
    width
}:{
    closeIt: Function, 
    title: string, 
    msg: string, 
    confirm?: boolean,
    titleColor?: string, 
    titleBgColor?: string, 
    msgColor?: string, 
    msgBgColor?: string, 
    onYes?: MouseEventHandler, 
    onNo?: MouseEventHandler, 
    width?: string
}){
    return createPortal(
        <div className = "myModal" onClick = {e => confirm?null:closeIt()}>
            <div className = "modalContent cssNotifications" style = {{width: width || 300}}>
                <div>
                    <div className = "modalHeader" style = {{backgroundColor: titleBgColor, color: titleColor}}>{title}</div>
                    <div className = "cssContent" style = {{backgroundColor: msgBgColor, color: msgColor}}>{msg}</div>
                    {confirm?
                    <div className = "modal-footer">
                        <div className = "btn btn-success" onClick = {onYes}>Yes</div>
                        <div className = "btn btn-dark" onClick = {onNo}>No</div>
                    </div>
                    :null}
                </div>
            </div>
        </div>
        , document.getElementById("app-root")!
    );
}